let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1bqZ7")).then(() => parcelRequire('5pp10'));